// <s-accordion> — smooth height for ALBRÄ editorial accordions (.albra-accordion details) in every browser.
// One Web Animations height tween per toggle (320ms), so the motion is identical everywhere.
// Native <details> stays the source of truth: without JS, or under reduced motion, it simply opens and closes.
// Reduced motion is read from the CSS switch --albra-motion (config/styles.css), the single source for CSS and JS.
const DURATION = 320;
const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

class Accordion extends HTMLElement {
  #controller = null;


  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('click', (event) => this.#onClick(event), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #onClick(event) {
    if (getComputedStyle(document.documentElement).getPropertyValue('--albra-motion').trim() === 'off') return;
    const summary = event.target.closest('summary');
    const details = summary?.parentElement;
    if (!details || details.localName !== 'details' || !details.closest('.albra-accordion') || !this.contains(details)) return;

    event.preventDefault();
    details.getAnimations().forEach((animation) => animation.cancel());

    // A click during a closing tween reverses it (the element is still [open] until the tween finishes).
    const closing = details.open && details.dataset.closing !== 'true';
    if (closing) details.dataset.closing = 'true';
    else delete details.dataset.closing;
    const startHeight = details.offsetHeight;
    if (!closing) details.open = true;
    const frame = details.offsetHeight - details.clientHeight;
    const endHeight = closing ? summary.offsetHeight + frame : details.offsetHeight;

    details.style.overflow = 'clip';
    const animation = details.animate({ blockSize: [`${startHeight}px`, `${endHeight}px`] }, { duration: DURATION, easing: EASING });
    const finish = () => {
      if (closing) details.open = false;
      delete details.dataset.closing;
      details.style.removeProperty('overflow');
    };
    animation.addEventListener('finish', finish, { once: true });
    animation.addEventListener('cancel', () => details.style.removeProperty('overflow'), { once: true });
  }
}

if (!customElements.get('s-accordion')) customElements.define('s-accordion', Accordion);
